export default __webpack_public_path__ + "media/images/react_icons/logged_user-white-b311e16212e9ac6147782156dda931a2.svg";